/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownTravelInsuranceStatus } from '../models/db_DropdownTravelInsuranceStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TravelInsuranceStatuses {
    /**
     * Get a list of travel insurance statuses
     * @returns db_DropdownTravelInsuranceStatus OK
     * @throws ApiError
     */
    public static listTravelInsuranceStatuses(): CancelablePromise<Array<db_DropdownTravelInsuranceStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/travel-insurance-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
